// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"94755f68","61":"207ee9b3","64":"81d1e1a1","106":"536c58ec","304":"80005610","402":"e4fc5e31","438":"f657fc03","593":"ba280298","645":"00becc54","787":"9c92cdb4","801":"15bfacb6"}[chunkId] + ".chunk.js";
};